import Rollbar from "../lib/rollbar";
import type { RollbarInstance } from "../lib/rollbarTypes";

const rollbar = new Rollbar({
  accessToken: process.env.REACT_APP_ROLLBAR_KEY,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled:
    process.env.REACT_APP_ENV_NAME === "production" ||
    process.env.REACT_APP_ENV_NAME === "staging",
  payload: {
    environment: process.env.REACT_APP_ENV_NAME,
    context: "UI",
    client: {
      javascript: {
        guess_uncaught_frames: true,
        source_map_enabled: true,
      },
    },
  },
}) as RollbarInstance;

export { rollbar };
